<i18n src="../../locales/lang.json"></i18n>
<template>
  <div v-show="activated == true" class="container-fluid px-0" style="height:100%;">
    <ul class="nav nav-tabs nav-tabs-highlight mb-0 mr-0" id="procedureTabs" v-show="activated == true && showtabs == true">
      <li class="nav-item" style="border-left-width:0px !important">
        <a @click="activateWorkMode" v-bind:href="'#procedure-detail-workPanel' + getId()" style="" class="nav-link active show" data-toggle="tab">
          <i class="icon-stack-check"></i>
        </a>
      </li>
      <li class="nav-item" v-show="$store.getUserPermissionLevel() > 2">
        <a @click="activateEditMode" v-bind:href="'#procedure-detail-editPanel' + getId()" class="nav-link" data-toggle="tab">
          <i class="icon-pencil7"></i>
        </a>
      </li>
      <li class="nav-item" v-show="$store.getUserPermissionLevel() > 0">
        <a @click="enableDiscussionMode" v-bind:href="'#procedure-detail-discussionPanel' + getId()" class="nav-link" data-toggle="tab">
          <i class="icon-bubbles3"></i>
          <span v-if="hasMessages()" class="badge badge-warning badge-pill float-right" style="top:3px;right:0px;position:absolute">{{messagescount}}</span>
        </a>
      </li>
      <li class="nav-item" v-show="$store.getUserPermissionLevel() > 2">
        <a @click="enableHistoryMode" v-bind:href="'#procedure-detail-historyPanel' + getId()" class="nav-link" data-toggle="tab">
          <i class="icon-folder-check"></i>
        </a>
      </li>
      <li class="nav-item" v-show="$store.getUserPermissionLevel() > 2">
        <a @click="enableSchHistoryMode" v-bind:href="'#procedure-sch-detail-historyPanel' + getId()" class="nav-link" data-toggle="tab">
          <i class="icon-folder-check"></i>
        </a>
      </li>
      <li class="nav-item" v-show="$store.getUserPermissionLevel() > 2">
        <a @click="enableAdvancedMode" v-bind:href="'#procedure-detail-advancedPanel' + getId()" class="nav-link" data-toggle="tab">
          <i class="icon-cog3"></i>
        </a>
      </li>
      <li class="nav-item" v-show="$store.getUserPermissionLevel() > 2">
        <a @click="enableSchTagMode" v-bind:href="'#procedure-sch-detail-tagPanel' + getId()" class="nav-link" data-toggle="tab">
          <i class="fa fa-tag"></i>
        </a>
      </li>
      <li class="nav-item" v-if="isSuperAdmin == true">
        <a @click="enableConditionsMode" v-bind:href="'#procedure-sch-detail-conditionsPanel' + getId()" class="nav-link" data-toggle="tab">
          <i class="icon-markup"></i>
        </a>
      </li>
    </ul>
    <div v-show="activated == true" class="container-fluid editor-container" v-bind:id="getId()" ref="container" style="">
      <div style="position: absolute; left:-41px;margin-top:-3px; display:none">
        <procedure-page-selector></procedure-page-selector>
      </div>
      <div class="row" style="height: 100%">
        <div class="col p-2" style="padding-left:0px !important">
          <div class="tab-content border-top-0 rounded-top-0 mb-0" style="height: 100%">

            <div class="procedure-quicksave" v-bind:class="getBottomPaddingClass" v-show="isChanged == true && showDoneReject == false">
              <procedure-quicksave @procedure_saved="onsave"></procedure-quicksave>
            </div>
            <div class="procedure-done-reject" v-bind:class="getBottomPaddingClass" v-show="scheduleid != null && loaded == true && (assigned == user || isshifttask == true || $store.getUserPermissionLevel() > 2) && showDoneReject == true && hasSlideShow == false">
              <procedure-new-done-reject ref="vueProcedureSetStatus" @add_chat_message="addChatMessage" v-bind:scheduleid="scheduleid"></procedure-new-done-reject>
            </div>
            <div v-bind:id="'procedure-detail-workPanel' + getId()" class="tab-pane fade show active pl-1" style="height: 100%">
              <procedure-workmode  v-bind:hasslideshow="hasSlideShow" @add_pending_chat_message="addPendingChatMessage" v-bind:isshifttask="isshifttask" v-bind:assigned="assigned" ref="workmode" @done="save" @assign="assign" @advanced="advanced" @changed="changed" v-bind:scheduleid="scheduleid"></procedure-workmode>

            </div>
            <div v-bind:id="'procedure-detail-editPanel' + getId()" class="tab-pane fade" style="padding-right: 44px;height: 100%">
              <procedure-editmode ref="editmode"></procedure-editmode>
            </div>
            <div v-bind:id="'procedure-detail-discussionPanel' + getId()" class="tab-pane fade pl-1" v-bind:style="getHeight">
              <discuss-singlethread mode="flat" v-bind:forumname="calculatedforumname()" v-bind:threadtitle="$t('template') + ' ' + procedure.ProcedureName+' ('+ scheduleid + ')'" ref="procedureDiscussion"></discuss-singlethread>
            </div>
            <div v-bind:id="'procedure-detail-historyPanel' + getId()" class="tab-pane fade pl-1" style="height: 100%">
              <procedure-historymode ref="procedureHistory"></procedure-historymode>
            </div>
            <div v-bind:id="'procedure-sch-detail-historyPanel' + getId()" class="tab-pane fade pl-1" style="height: 100%">
              <procedure-sch-historymode ref="procedureSchHistory"></procedure-sch-historymode>
            </div>
            <div v-bind:id="'procedure-detail-advancedPanel' + getId()" class="tab-pane fade pl-1" style="height: 100%">
              <procedure-advanced-settings ref="procedureAdvancedSettings"></procedure-advanced-settings>
            </div>
            <div v-bind:id="'procedure-sch-detail-tagPanel' + getId()" class="tab-pane fade pl-1" style="height: 100%">
              <procedureschedule-tag ref="procedureSchTag"></procedureschedule-tag>
            </div>
            <div v-bind:id="'procedure-sch-detail-conditionsPanel' + getId()" v-if="isSuperAdmin == true" class="tab-pane fade pl-1" style="height: 100%">
              <conditions-editor ref="conditionsEditor" @change="conditionsChanged"></conditions-editor>
            </div>
          </div>
        </div>
      </div>
    </div>
    <procedure-save @procedure_saved="onsave" v-bind:isClone="isClone" ref="saveModal"></procedure-save>
    <procedure-assign v-bind:siteid="siteid" ref="assignModal" v-bind:user="user"></procedure-assign>
    <common-ticker ref="ticker"></common-ticker>
  </div>

</template>

<script>
  let user = '';
  var mode = "work"

  var hideWork = false;

  export default {
    name: "procedure-details",
    components: {

    },
    props: {
      procedureid: {
        required: false,
        type: Number,
        default: null
      },
      date: {
        required: false,
        type: String,
        default: null
      },
      siteid: {
        type: Number,
        default: -1
      },
      scheduleid: {
        required: false,
        type: String,
        default: null
      },
      user: {
        required: false,
        type: String,
        default: ""
      },
      messagescount: {
        required: false,
        type: Number,
        default: 0,
      },
      isClone: {
        required: false,
        type: Boolean,
        default: false
      },
      isshifttask: {
        required: false,
        type: Boolean,
        default: false
      },

      assigned: {
        required: false,
        type: String,
        default: null
      }
    },
    data() {
      return {
        callFrom: '',
        activated: false,
        show: false,
        mode,
        hideWork,
        isSuperAdmin: false,
        pendingMessage: '',
        loaded: false,
        showDoneReject: true,
        showtabs: true,
        hasSlideShow: false,
        procedure: {
          ProcedureId: 0,
          ProcedureName: "",
          ProcedureScheduleName: "",
          Description: "",
          Elements: [],
          EstimatedTime: 0,
          CategoryId: 0,
          Priority: 0,
          Status: 0,
          NewCategoryName: null,
          Locked: false,
          Private: false,

          Settings: {
            Property: {}
          }
        }
      }
    },
    computed: {
      getHeight: {
        get() {
          var otherHeight = 60;
          if (this.$store.isMobile())
            otherHeight = 90;
          if (this.$store.getHelptextVisible())
            otherHeight += 80;
          if (this.$store.getMenuVisible())
            otherHeight += 65;
          var height = window.innerHeight;
          height = height - otherHeight;
          return "height: " + height + "px;"
        },
      },
      getBottomPaddingClass: {
        get() {
          var style = "padding-"
          if (this.$store.getHelptextVisible()) {
            style += "helptext-"
          }
          else {
            style += "nohelptext-"
          }
          if (this.$store.getMenuVisible()) {
            style += "menu"
          }
          else {
            style += "nomenu"
          }
          return style
        },
      },
      getBottomPadding: {
        get() {
          if ($store.isMobile()) {
            if (this.$store.getHelptextVisible()) {
              return "padding-bottom:140px;"
            }
            return "padding-bottom:65px;"
          }
          if (this.$store.getHelptextVisible()) {
            return "padding-bottom:80px;"
          }
          return "padding-bottom:0px;"
        },
      },
      isChanged: {
        get() {
          return this.show;
        }
      }
    },
    methods: {
      setCallFrom(call) {
        this.$refs.vueProcedureSetStatus.setCallFrom(call);
        this.callFrom = call;
      },
      doActivation() {
        if (this.activated == false) {
          this.activated = true;
          this.$forceUpdate();
        }
      },
      onsave() {
        if (this.pendingMessage != '') {
          this.addChatMessage(this.pendingMessage)
        }
      },
      addPendingChatMessage(message) {
        this.doActivation();
        this.pendingMessage = message;
      },
      addChatMessage(message) {
        this.doActivation();
        if (this.callFrom == 'microservice') {
          this.$refs.procedureDiscussion.addMicroserviceMessage(message);
          this.pendingMessage = '';
        } else {
          this.$refs.procedureDiscussion.addMessage(message);
          this.pendingMessage = '';
          vm.$root.$emit('procedure_editor_can_close');
        }       
      },
      hasMessages() {
        return this.messagescount > 0;
      },
      calculatedforumname() {
        var isPrivate = this.procedure.Private;
        if (this.procedure.Settings != null)
          if (this.procedure.Settings.Property["EnablePrivateChat"] == "True")
            isPrivate = true;
        if (isPrivate == true)
          return "Private";
        return null;
      },
      saveIfChanged() {
        this.doActivation();
        if (this.$store.isChanged()) {
          this.$refs.saveModal.openAndDoClosable();
        }
      },
      save() {
        this.doActivation();
        this.$refs.saveModal.openAndDoClosable();
      },
      assign() {
        this.doActivation();
        this.$refs.assignModal.user = this.user;
        this.$refs.assignModal.open();
      },
      advanced() {

      },
      activateEditMode(isShowTagtab) {
        this.mode = "edit";
        this.showDoneReject = false;
        this.activateTab("procedure-detail-editPanel");
        vm.$root.$emit('nux', this.$store.translate('nux_procedure_editmode'));
        vm.$root.$emit('menu', '#editProcedureMenu', 'open');
        this.hideShowTabs(isShowTagtab);
      },
      enableEditMode(isShowTagtab) {
        this.doActivation();
        this.showDoneReject = false;
        this.mode = "edit";
        this.activateEditMode(isShowTagtab);
        this.$forceUpdate();
      },
      activateWorkMode(defaulttab) {

        this.mode = "work";
        this.doActivation();
        switch (defaulttab) {
          case "chat":
            this.enableDiscussionMode();
            this.showDoneReject = false;
            break;
          default:
            this.showDoneReject = true;
            this.activateTab("procedure-detail-workPanel");
            vm.$root.$emit('nux', this.$t('nux_procedure_workmode'));
            vm.$root.$emit('menu', '#workModeMenu', 'open');

            if (this.$store.getUserPermissionLevel() <= 0) {
              this.showtabs = false; // if only one tab then no need to show tabs tab
            }
            break;
        }

        this.hideShowTabs();
      },
      hideShowTabs(isShowTagtab) {
        if (this.mode == "work") {
          this.showTab("procedure-sch-detail-tagPanel");
          this.hideTab("procedure-detail-advancedPanel");
          this.showTab("procedure-detail-editPanel");
          this.hideTab("procedure-detail-historyPanel");
          this.showTab("procedure-sch-detail-historyPanel");
        }
        else if (this.mode == "editlimited") {
          if (this.hideWork)
            this.hideTab("procedure-detail-workPanel");
          else
            this.showTab("procedure-detail-workPanel");

          this.showTab("procedure-detail-editPanel");
        }

        else if (this.mode == "edit") {

          if (this.hideWork)
            this.hideTab("procedure-detail-workPanel");
          else
            this.showTab("procedure-detail-workPanel");
          if (isShowTagtab !== true) {
            this.hideTab("procedure-sch-detail-tagPanel");
          }
          this.showTab("procedure-detail-advancedPanel");
          this.showTab("procedure-detail-editPanel");
          this.hideTab("procedure-sch-detail-historyPanel");
          this.showTab("procedure-detail-historyPanel");
        }
      },
      enableWorkMode(defaulttab) {
        this.doActivation();
        this.showDoneReject = true;
        this.mode = "work";
        this.activateWorkMode(defaulttab);
      },
      enableDiscussionMode() {
        this.doActivation();
        this.showDoneReject = false;
        this.$refs.procedureDiscussion.setThreadId(-1);
        this.$refs.procedureDiscussion.uid = "procedurescheduleid:" + this.scheduleid;//"procedure:" + this.procedure.ProcedureName;
        this.$refs.procedureDiscussion.reload();

        this.activateTab("procedure-detail-discussionPanel");
        vm.$root.$emit('nux', this.$store.translate('nux_procedure_discussion'));
        vm.$root.$emit('menu', '#defaultMenu', 'open');
      },
      enableHistoryMode() {
        this.doActivation();
        this.showDoneReject = false;
        this.$refs.procedureHistory.loadProcedureHistory();
        this.activateTab("procedure-detail-historyPanel");
        vm.$root.$emit('nux', this.$store.translate('nux_procedure_history'));
        vm.$root.$emit('menu', '#defaultMenu', 'open');
      },
      enableSchHistoryMode() {
        this.doActivation();
        this.showDoneReject = false;
        this.$refs.procedureSchHistory.loadProcedureSchHistory();
        this.activateTab("procedure-sch-detail-historyPanel");
        vm.$root.$emit('nux', this.$store.translate('nux_procedure_history'));
        vm.$root.$emit('menu', '#defaultMenu', 'open');
      },
      enableMaterialMode() {
        this.doActivation();
        this.showDoneReject = false;
        this.activateTab("procedure-detail-materialPanel");
        vm.$root.$emit('nux', this.$t('nux_procedure_material'));
        vm.$root.$emit('menu', '#defaultMenu', 'open');
      },
      enableTimespentMode() {
        this.doActivation();
        this.showDoneReject = false;
        this.activateTab("procedure-detail-timespentPanel");
        vm.$root.$emit('nux', this.$t('nux_procedure_enabletimespent'));
        vm.$root.$emit('menu', '#defaultMenu', 'open');
      },
      hideWorkMode() {
        this.doActivation();
        this.hideWork = true;
        this.showDoneReject = false;
      },
      enableSchTagMode() {
        this.doActivation();
        this.showDoneReject = false;
        this.$refs.procedureSchTag.loadTags();
        this.activateTab("procedure-sch-detail-tagPanel");
        vm.$root.$emit('nux', this.$store.translate('nux_procedure_discussion'));
        vm.$root.$emit('menu', '#defaultMenu', 'open');
      },
      enableConditionsMode() {
        this.doActivation();
        this.showDoneReject = false;
        this.activateTab("procedure-sch-detail-conditionsPanel");
        vm.$root.$emit('menu', '#workModeMenu', 'open');
      },
      enableAdvancedMode() {
        this.doActivation();
        this.mode = "editlimited"
        this.activateTab("procedure-detail-advancedPanel");
        this.hideShowTabs();
        vm.$root.$emit('nux', this.$t('nux_procedure_advanced'));
        vm.$root.$emit('menu', '#defaultMenu', 'open');
        //vm.$root.$emit('menu', '#editProcedureMenu', 'open');
      },
      activateTab(id) {
        $('#procedureTabs a[href="#' + id + this.getId() + '"]').tab('show');
      },
      hideTab(id) {
        $('#procedureTabs a[href="#' + id + this.getId() + '"]').hide();
      },
      showTab(id) {
        $('#procedureTabs a[href="#' + id + this.getId() + '"]').show();
      },
      promptMessage() {
        this.enableDiscussionMode();
        //this.activateTab("procedure-detail-discussionPanel");
        vm.$root.$emit('menu', '#defaultMenu', 'open');
      },
      isClosable() {
        this.doActivation();
        if (!this.$store.isChanged() && this.$refs.saveModal.isClone == false) {
          vm.$root.$emit('procedure_editor_can_close');
        }
        else {
          this.$refs.saveModal.openAndDoClosable();
        }
      },
      async loadProcedure(procedureid, scheduleid) {
        this.doActivation();
        if (this.$store.isChanged() == true) {
          this.save();
          return;
        }
        this.doLoadProcedure(procedureid, scheduleid)
      },
      async doLoadProcedure(procedureid, scheduleid) {
        this.procedureid = procedureid;
        this.doActivation();
        try {
          if (this.$refs.ticker !== undefined) {
            this.$refs.ticker.start(this.$refs.container.getAttribute('id'));
          }
          var url = '/api/Procedures/v1/GetProcedureDetail?something=' + (new Date()).getTime() + '&procedureId=' + procedureid;
          if (this.scheduleid != null) {
            url += '&procedureScheduleId=' + scheduleid;
          }
          this.$http.get(url).then(async response => {

            var proc = response.data;
            this.loadProcedureInChildComponents(proc);
            var thisContext = this;

            this.reload();
            this.procedure = proc;
            // Try not to wait
            setTimeout(function () {
              thisContext.$store.commit('load', proc)
            }, 5);
            if (this.$refs.ticker !== undefined) {
              this.$refs.ticker.end(this.$refs.container.getAttribute('id'));
            }

            this.hasSlideShow = false;
            for (var i = 0; i < proc.Elements.length; i++) {
              if (proc.Elements[i].ElementType == 12)
                this.hasSlideShow = true;
            }

            this.loaded = true;
          });
        }
        catch (err) {
          this.$refs.ticker.end(this.$refs.container.getAttribute('id'));
        }
      },
      async reload() {
        this.doActivation();
        if (this.procedure.Private == true) {
          this.$refs.procedureDiscussion.forumname = "-private";
        }
        else {
          if (this.$refs.procedureDiscussion !== undefined) {
            this.$refs.procedureDiscussion.forumname = null;
          }
        }

        if (this.$refs.procedureHistory !== undefined) {
          this.$refs.procedureHistory.procedureid = this.procedureid;
        }
        if (this.$refs.procedureAdvancedSettings !== undefined) {
          this.$refs.procedureAdvancedSettings.isSuperAdmin = this.isSuperAdmin;
        }
        if (this.$refs.procedureSchHistory !== undefined) {
          this.$refs.procedureSchHistory.proSchId = this.scheduleid;
        }
        if (this.$refs.procedureSchTag !== undefined) {
          this.$refs.procedureSchTag.proSchId = this.scheduleid;
          this.$refs.procedureSchTag.procId = this.procedureid;
        }
        if (this.$refs.procedureDiscussion !== undefined) {
          this.$refs.procedureDiscussion.setThreadId(-1);
          this.$refs.procedureDiscussion.uid = "procedurescheduleid:" + this.scheduleid;
        }
        //if (this.$refs.conditionsEditor !== undefined) {
        //  if (this.procedure.Settings.Conditions != null && this.$refs.conditionsEditor)
        //    this.$refs.conditionsEditor.setData(this.procedure.Settings.Conditions)
        //}
      },
      async doConditionUpdate() {


        /*
        alert("UserInputs:" + JSON.stringify(this.procedure.Elements[0].Elements[0].UserInputs));

        alert("Before, visibility on element:" + this.procedure.Elements[0].Elements[1].Elements[0].Visible);
        alert("Before, Hidden on element:" + this.procedure.Elements[0].Elements[1].Elements[0].Hidden);

        */

        this.doActivation();


        //alert(JSON.stringify(this.procedure))
        var response = await this.$http.post(
          '/api/Procedure/CheckConditions',
          this.procedure,
          {
            headers: {
              'Content-Type': 'application/json',
              "Accept": "application/json"
            }
          }
        )
          .then(async response => {

            this.procedure = response.data;

            this.$store.commit('loadnewProcedureWithoutStateChange', this.procedure);

            this.loadProcedureInChildComponents(this.procedure);

            var proc = this.procedure;

            for (var i = 0; i < proc.Settings.Conditions.length; i++) {
              if (proc.Settings.Conditions[i].Action == "Call" && proc.Settings.Conditions[i].Active == true) {
                eval(proc.Settings.Conditions[i].TargetValue);
              }
            }

            //var thisContext = this;

            //this.reload();
            //var proc = response.data;
            //this.procedure = response.data;
            // Try not to wait
            //setTimeout(function () {
            //  thisContext.$store.commit('load', proc)
            //}, 5);
            //if (this.$refs.ticker !== undefined) {
            //  this.$refs.ticker.end(this.$refs.container.getAttribute('id'));
            //}

            //this.hasSlideShow = false;
            //for (var i = 0; i < proc.Elements.length; i++) {
            //  if (proc.Elements[i].ElementType == 12)
            //    this.hasSlideShow = true;
            //}

            //this.loaded = true;

            //alert("After, visibility on element:" + proc.Elements[0].Elements[1].Elements[0].Visible);
            //alert("After, Hidden on element:" + proc.Elements[0].Elements[1].Elements[0].Hidden);

            //this.$forceUpdate();


          });
      },
      getId() {
        return "container_" + this._uid;
      },
      conditionsChanged() {
        this.$store.markAsChanged();
      },
      changed() {
        this.doActivation();
        this.doConditionUpdate();
      },
      async doSmallReset(newProcedure) {

        this.doActivation();
        if (this.procedureid != null) {
          this.doLoadProcedure(this.procedureid, this.scheduleid)
        }
        else {
          this.loadProcedureInChildComponents(newProcedure);
        }
      },
      async doReset(newProcedure) {
        this.doActivation();
        //alert("doReset");

        if (this.procedureid != null) {
          this.doLoadProcedure(this.procedureid, this.scheduleid)
        }
        else {

          var proc = this.$store.getCopy();
          this.$store.commit('loadnewProcedure', proc)

        }

      },
      async loadProcedureInChildComponents(procedure) {
        if (this.$refs.workmode !== undefined) {
          this.$refs.workmode.setProcedure(procedure)
          this.$refs.workmode.loadElements(procedure.Elements)
        }
        var thisContext = this;
        if (thisContext.$refs.editmode !== undefined) {
          setTimeout(function () {
            thisContext.$refs.editmode.setProcedure(procedure)
            thisContext.$refs.editmode.loadElements(procedure.Elements)
          }, 100)
        }
      },
      checkShow(show) {
        this.show = show;
        this.$forceUpdate();
      },
      async doAfterRefresh(procedure) {
        this.loadProcedureInChildComponents(procedure)
      }
    },
    mounted() {

      if (this.$store.getUserPermissionLevel() > 5)
        this.isSuperAdmin = true;
      if (this.procedureid != null) {
        this.loadProcedure(this.procedureid, this.scheduleid);
      }
      this.$root.$on('check_if_procedure_editor_is_closable', this.isClosable);
      this.$root.$on('procedure_open_chat', this.promptMessage);
      this.$root.$on('procedure_reset', this.doReset);
      this.$root.$on('procedure_statusreset', this.doSmallReset);
      this.$root.$on('procedure_changed', this.checkShow);
      this.$root.$on('procedure_refresh', this.doAfterRefresh);

      if (this.$refs.procedureAdvancedSettings !== undefined) {
        this.$refs.procedureAdvancedSettings.isSuperAdmin = this.isSuperAdmin;
      }
    },
    created: function () {

    },
    watch: {

    },
  };

</script>

<style scoped>
  .padding-helptext-menu {
    padding-bottom: 80px;
  }

  .padding-helptext-nomenu {
    padding-bottom: 80px;
  }

  .padding-nohelptext-menu {
    padding-bottom: 0px;
  }

  .padding-nohelptext-nomenu {
    padding-bottom: 0px;
  }


  .padding-helptextmargin {
    padding-bottom: 80px;
  }

  .padding-nomargin {
    padding-bottom: 0px;
  }




  .nav-link.active::before {
  }

  .nav-link {
    padding-left: 15px;
    padding-right: 15px;
  }

    .nav-link.active {
      background-color: white !important;
    }

  .tab-content {
    /*background-color: white !important;*/
  }

  #procedureTabs {
    margin-right: 8px;
    margin-left: -1px !important;
  }

  .editor-container {
    height: calc(-105px + 100vh);
    overflow-y: auto;
    overflow-x: visible;
  }

  .procedure-quicksave {
    position: fixed;
    bottom: 12px;
    right: 17px;
    z-index: 1002;
    width: 30%;
    z-index: 5002;
  }

  .procedure-done-reject {
    position: fixed;
    bottom: 12px;
    right: 17px;
    z-index: 1002;
    width: 30%;
    z-index: 5001;
  }

  @media (max-width: 768px) {

    .padding-helptext-menu {
      padding-bottom: 145px;
    }

    .padding-helptext-nomenu {
      padding-bottom: 80px;
    }

    .padding-nohelptext-menu {
      padding-bottom: 65px;
    }

    .padding-nohelptext-nomenu {
      padding-bottom: 0px;
    }

    .procedure-quicksave {
      width: unset;
      right: 17px;
      left: 24px;
      bottom: 40px;
    }

    .procedure-done-reject {
      width: unset;
      right: 17px;
      left: 24px;
      bottom: 40px;
    }

    #procedureTabs {
      margin-right: 0px;
      margin-left: 0px;
    }

    .editor-container {
      height: calc(-50px + 100%);
      overflow-y: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-details.vue